<template>

	<div class="wrapper">
		<div class="section section-blogs-2 topsearch">
			<div class="container main">
				<div class="md-layout">
					<div class="md-layout-item md-size-100 md-small-size-100 mx-auto">
						<router-link :to="{ name: 'modelListRoof', params: {dictionaryId: dictCode, page: page} }"
									 id="buttonback">
							<md-icon>keyboard_arrow_left</md-icon>
							Назад к списку справочников
						</router-link>
					</div>
					<div class="md-layout-item md-size-100 md-small-size-100 mx-auto">

						<div class="name">
							<h3 class="title">Редактирование элемента справочника моделей окон <br><br> </h3>
							<div class="md-layout-item md-size-100 md-xsmall-size-100 fieldsep" v-if="selectedDataId">

								<div class="md-layout-item md-size-50 md-xsmall-size-100 text-center fieldsep">
									<md-field :class="getValidationClass('name')">
										<label>{{mapElementName['name']}}</label>
										<md-input type="text" v-if="action === 'delete'"
												  v-model="form['name']"></md-input>
										<md-input type="text" v-else v-model="form['name']"></md-input>
										<span class="md-error" v-if="!$v.form.name.required">Обязательно для заполнения</span>
									</md-field>
								</div>

								<div class="md-layout-item md-size-50 md-xsmall-size-100 text-center fieldsep">
									<md-field :class="getValidationClass('price')">
										<label>{{mapElementName['price']}}</label>
										<md-input type="text" v-if="action === 'delete'"
												  v-model="form['price']"></md-input>
										<md-input v-mask="'#######'" type="text" v-else v-model="form['price']"></md-input>
										<span class="md-error" v-if="!$v.form.price.required">Обязательно для заполнения</span>
									</md-field>
								</div>
								<div class="md-layout-item md-size-50 md-xsmall-size-100 fieldsep">

									<h4 class="title">Фотография</h4>
									<h5>Фото:</h5>
									<img :src="itemPhoto" v-if="itemPhoto" style="height: 320px; width: auto;">
									<div style="margin-top: 10px;">
										<label>Выбрать фото
											<input id="photo" ref="photo" type="file"
												   v-on:change="handleFileUpload('photo')"/>
										</label>
									</div>
								</div>

								<div class="md-layout-item md-size-50 md-xsmall-size-100 text-center fieldsep">
									<md-field :class="getValidationClass('comment')">
										<label>{{mapElementName['comment']}}</label>
										<md-input type="text" v-if="action === 'delete'"
												  v-model="form['comment']"></md-input>
										<md-input type="text" v-else v-model="form['comment']"></md-input>
										<span class="md-error" v-if="!$v.form.comment.required">Обязательно для заполнения</span>
									</md-field>
								</div>

								<div v-if="selectedDataId === 'new'" class="md-layout-item md-size-50 md-xsmall-size-100 text-center fieldsep">
									<md-field :class="getValidationClass('minHeight')">
										<label>{{mapElementName['minHeight']}}</label>
										<md-input type="text" v-if="action === 'delete'"
												  v-model="form['minHeight']"></md-input>
										<md-input type="text" v-else v-model="form['minHeight']"></md-input>
										<span class="md-error" v-if="!$v.form.minHeight.required">Обязательно для заполнения</span>
									</md-field>
								</div>

								<div v-if="selectedDataId === 'new'" class="md-layout-item md-size-50 md-xsmall-size-100 text-center fieldsep">
									<md-field :class="getValidationClass('maxHeight')">
										<label>{{mapElementName['maxHeight']}}</label>
										<md-input type="text" v-if="action === 'delete'"
												  v-model="form['maxHeight']"></md-input>
										<md-input type="text" v-else v-model="form['maxHeight']"></md-input>
										<span class="md-error" v-if="!$v.form.maxHeight.required">Обязательно для заполнения</span>
									</md-field>
								</div>

								<div v-if="selectedDataId === 'new'" class="md-layout-item md-size-50 md-xsmall-size-100 text-center fieldsep">
									<md-field :class="getValidationClass('heightStep')">
										<label>{{mapElementName['heightStep']}}</label>
										<md-input type="text" v-if="action === 'delete'"
												  v-model="form['heightStep']"></md-input>
										<md-input type="text" v-else v-model="form['heightStep']"></md-input>
										<span class="md-error" v-if="!$v.form.heightStep.required">Обязательно для заполнения</span>
									</md-field>
								</div>

								<div v-if="selectedDataId === 'new'" class="md-layout-item md-size-50 md-xsmall-size-100 text-center fieldsep">
									<md-field :class="getValidationClass('minWidth')">
										<label>{{mapElementName['minWidth']}}</label>
										<md-input type="text" v-if="action === 'delete'"
												  v-model="form['minWidth']"></md-input>
										<md-input type="text" v-else v-model="form['minWidth']"></md-input>
										<span class="md-error" v-if="!$v.form.minWidth.required">Обязательно для заполнения</span>
									</md-field>
								</div>

								<div v-if="selectedDataId === 'new'" class="md-layout-item md-size-50 md-xsmall-size-100 text-center fieldsep">
									<md-field :class="getValidationClass('maxWidth')">
										<label>{{mapElementName['maxWidth']}}</label>
										<md-input type="text" v-if="action === 'delete'"
												  v-model="form['maxWidth']"></md-input>
										<md-input type="text" v-else v-model="form['maxWidth']"></md-input>
										<span class="md-error" v-if="!$v.form.maxWidth.required">Обязательно для заполнения</span>
									</md-field>
								</div>

								<div v-if="selectedDataId === 'new'" class="md-layout-item md-size-50 md-xsmall-size-100 text-center fieldsep">
									<md-field :class="getValidationClass('widthStep')">
										<label>{{mapElementName['widthStep']}}</label>
										<md-input type="text" v-if="action === 'delete'"
												  v-model="form['widthStep']"></md-input>
										<md-input type="text" v-else v-model="form['widthStep']"></md-input>
										<span class="md-error" v-if="!$v.form.widthStep.required">Обязательно для заполнения</span>
									</md-field>
								</div>

								<div class="md-layout-item md-gutter md-size-100 md-xsmall-size-100 fieldsep">

									<template v-if="selectedDataId">
										<md-button @click="validateData(saveItem)"
												   class="md-button md-success md-theme-default"
												   v-if="action !== 'delete'">
											Сохранить окно
										</md-button>

										<md-button @click="validateData(deleteItem)"
												   class="md-button md-primary  md-theme-default"
												   v-if="action === 'delete'">
											Удалить
										</md-button>

									</template>
								</div>
								<div class="grid-siz" v-if="selectedDataId !== 'new'">

									<hr>
									<h4 class="title">Ценовая сетка по размерам</h4>
									<div v-if="pricesDeleted === false" class="prix-table">
										<table>
											<tr>
												<th></th>
												<th v-for="priceColName in priceColNames">{{priceColName}}</th>
											</tr>
											<tr v-for="priceRowName in priceRowNames">
												<th>
													{{priceRowName}}
												</th>
												<td v-for="priceColName in priceColNames">
													<input class="short-inp" type="number" v-model="pricesModel.prices[getModelIndex(priceRowName, priceColName)].price">
												</td>
											</tr>
										</table>
									</div>
									<div v-else>


										<div class="md-layout-item md-size-50 md-xsmall-size-100 text-center fieldsep">
											<md-field :class="getValidationClass('minHeight')">
												<label>{{mapElementName['minHeight']}}</label>
												<md-input type="text" v-if="action === 'delete'"
														  v-model="form['minHeight']"></md-input>
												<md-input type="text" v-else v-model="form['minHeight']"></md-input>
												<span class="md-error" v-if="!$v.form.minHeight.required">Обязательно для заполнения</span>
											</md-field>
										</div>

										<div class="md-layout-item md-size-50 md-xsmall-size-100 text-center fieldsep">
											<md-field :class="getValidationClass('maxHeight')">
												<label>{{mapElementName['maxHeight']}}</label>
												<md-input type="text" v-if="action === 'delete'"
														  v-model="form['maxHeight']"></md-input>
												<md-input type="text" v-else v-model="form['maxHeight']"></md-input>
												<span class="md-error" v-if="!$v.form.maxHeight.required">Обязательно для заполнения</span>
											</md-field>
										</div>

										<div class="md-layout-item md-size-50 md-xsmall-size-100 text-center fieldsep">
											<md-field :class="getValidationClass('heightStep')">
												<label>{{mapElementName['heightStep']}}</label>
												<md-input type="text" v-if="action === 'delete'"
														  v-model="form['heightStep']"></md-input>
												<md-input type="text" v-else v-model="form['heightStep']"></md-input>
												<span class="md-error" v-if="!$v.form.heightStep.required">Обязательно для заполнения</span>
											</md-field>
										</div>

										<div class="md-layout-item md-size-50 md-xsmall-size-100 text-center fieldsep">
											<md-field :class="getValidationClass('minWidth')">
												<label>{{mapElementName['minWidth']}}</label>
												<md-input type="text" v-if="action === 'delete'"
														  v-model="form['minWidth']"></md-input>
												<md-input type="text" v-else v-model="form['minWidth']"></md-input>
												<span class="md-error" v-if="!$v.form.minWidth.required">Обязательно для заполнения</span>
											</md-field>
										</div>

										<div class="md-layout-item md-size-50 md-xsmall-size-100 text-center fieldsep">
											<md-field :class="getValidationClass('maxWidth')">
												<label>{{mapElementName['maxWidth']}}</label>
												<md-input type="text" v-if="action === 'delete'"
														  v-model="form['maxWidth']"></md-input>
												<md-input type="text" v-else v-model="form['maxWidth']"></md-input>
												<span class="md-error" v-if="!$v.form.maxWidth.required">Обязательно для заполнения</span>
											</md-field>
										</div>

										<div class="md-layout-item md-size-50 md-xsmall-size-100 text-center fieldsep">
											<md-field :class="getValidationClass('widthStep')">
												<label>{{mapElementName['widthStep']}}</label>
												<md-input type="text" v-if="action === 'delete'"
														  v-model="form['widthStep']"></md-input>
												<md-input type="text" v-else v-model="form['widthStep']"></md-input>
												<span class="md-error" v-if="!$v.form.widthStep.required">Обязательно для заполнения</span>
											</md-field>
										</div>
									</div>
									<br/>
									<div class="md-layout-item md-gutter md-size-100 md-xsmall-size-100 fieldsep">

										<template v-if="selectedDataId">
											<md-button @click="savePrices"
													   class="md-button md-success md-theme-default"
													   v-if="action !== 'delete' && pricesDeleted === false">
												Сохранить цены
											</md-button>
											<md-button @click="delPrices"
													   class="md-button md-success md-theme-default"
													   v-if="pricesDeleted === false">
												Удалить размерную сетку
											</md-button>
											<md-button @click="validateData(saveItem)"
													   class="md-button md-success md-theme-default"
													   v-else>
												Создать размерную сетку
											</md-button>

											<md-button @click="validateData(deleteItem)"
													   class="md-button md-primary  md-theme-default"
													   v-if="action === 'delete'">
												Удалить
											</md-button>

										</template>
									</div>
								</div>
							</div>
						</div>

					</div>
				</div>

			</div>
		</div>
		<md-dialog-alert
				:md-active.sync="alert"
				:md-content="alertText"
				md-confirm-text="OK" />
	</div>
</template>
<script>
	import { validationMixin } from 'vuelidate'
	import { checkAuthentication, reAuthenticate } from '@/utils/auth-api'
	import { required, minValue } from 'vuelidate/lib/validators'
	import { saveItem, getItem, getRoofPrices, uploadFile, getFile, deleteItem, deleteItemRoof, saveRoofPrices } from '@/utils/dict-api'
	import _ from 'lodash'

	export default {
		mixins: [
			validationMixin,
		],
		components: {},
		bodyClass: 'dictionary-data',
		props: ['page', 'action'],
		data () {
			return {
				pricesDeleted: false,
				priceColNames: [],
				priceRowNames: [],
				firstRow: [],
				pricesModel: [],
				pricesWin: [],
				alert: false,
				alertText: '',
				options: [],
				dictCode: this.$route.params.dictCode,
				dictionaryId: '',
				selectedDataId: this.$route.params.id,
				selectedData: null,
				form: {
					"id": 0,
					"name": "string",
					"type": 5,
					"price": 0,
					"comment": "",
					"minHeight": 0,
					"maxHeight": 0,
					"heightStep": 0,
					"minWidth": 0,
					"maxWidth": 0,
					"widthStep": 0,
					"photo": 0
				},
				itemData: {},
				photo: '',
				bigPhoto: '',
				mapElementName: {
					"name": "Название",
					"type": "Тип",
					"price": "Цена номинал",
					"comment": "Комментарий",
					"minHeight": "Мин. высота",
					"maxHeight": "Макс. высота",
					"heightStep": "Шаг высоты",
					"minWidth": "Мин. ширина",
					"maxWidth": "Макс. ширина",
					"widthStep": "Шаг ширины",
					"photo": "Фото"
				},
			}
		},
		computed: {
			_ () {
				return _
			},
			itemPhoto: function () {
				if (this.itemData.photo)
					return getFile(this.itemData.photo)
			},
		},
		validations() {
			return {
				form: {
					name : {
						required
					},
					type : {
						required
					},
					price : {
						required
					},
					comment : {
						required: false,
					},
					minHeight : {
						required: false,
					},
					maxHeight : {
						required: false,
					},
					heightStep : {
						required: false,
					},
					minWidth : {
						required: false,
					},
					maxWidth : {
						required: false,
					},
					widthStep : {
						required: false,
					}
				},
			}
		},
		methods: {
			delPrices() {
				this.pricesDeleted = true;
			},
			handleFileUpload (name) {
				this[name] = this.$refs[name].files[0]
				this.submitFile(name)
			},
			submitFile (name) {
				let formData = new FormData()
				formData.append('file', this[name])
				uploadFile(formData).then(response => {
					this.itemData[name] = response.id
					this.form[name] = response.id
				})
			},
			getValidationClass (fieldName) {
				const field = this.$v.form[fieldName]
				if (field) {
					return {
						'md-invalid': field.$invalid && field.$dirty,
					}
				}
			},
			validateData (sendFn) {
				if (this.selectedDataId === 'new' || this.pricesDeleted === true) {
					if (this.form.minHeight === null || parseFloat(this.form.minHeight) < 1) {
						this.alertText = "Не указана минимальная высота";
						this.alert = true;
						return false;
					}
					if (this.form.maxHeight === null || parseFloat(this.form.maxHeight) < 1) {
						this.alertText = "Не указана максимальная высота";
						this.alert = true;
						return false;
					}
					if (this.form.heightStep === null || parseFloat(this.form.heightStep) < 1) {
						this.alertText = "Не указан шаг высоты";
						this.alert = true;
						return false;
					}
					if (parseFloat(this.form.minHeight) > parseFloat(this.form.maxHeight)) {
						this.alertText = "Максимальная высота должа быть больше минимальной";
						this.alert = true;
						return false;
					}
					if (this.form.minWidth === null || parseFloat(this.form.minWidth < 1)) {
						this.alertText = "Не указана минимальная ширина";
						this.alert = true;
						return false;
					}
					if (this.form.maxWidth === null || parseFloat(this.form.maxWidth < 1)) {
						this.alertText = "Не указана максимальная ширина";
						this.alert = true;
						return false;
					}
					if (this.form.widthStep === null || parseFloat(this.form.widthStep < 1)) {
						this.alertText = "Не указан шаг ширины";
						this.alert = true;
						return false;
					}
					if (parseFloat(this.form.minWidth) > parseFloat(this.form.maxWidth)) {
						this.alertText = "Максимальная ширина должа быть больше минимальной";
						this.alert = true;
						return false;
					}
				}
				this.$v.form.$touch();

				if (!this.form.photo) {
					this.alertText = "Не добавлено фото"
					this.alert = true
					return
				}
				// if (!this.form.photo || !this.form.bigPhoto) {
				// 	this.alertText = "Не добавлены фото"
				// 	this.alert = true
				// 	return
				// }
				// _.forEach(this.form.techParams, item => {
				// 	if(!item.typeValVal || item.typeValVal.length === 0) {
				// 		this.alert = true
				// 		return
				// 	}
				// })
				// if(this.alert) {
				// 	this.alertText = "Не все технические параметры заполнены"
				// 	return
				// }
				// _.forEach(this.form.params, item => {
				// 	if(!item.typeValVal) {
				// 		this.alert = true
				// 		return
				// 	}
				// })
				// if(this.alert) {
				// 	this.alertText = "Не все параметры заполнены"
				// 	return
				// }
				if (this.$v.form.$invalid) {
					this.alertText = "Не все поля заполнены"
					this.alert = true
					return
				}
                if (!this.$v.form.$invalid) {
                    sendFn()
                }
            },
            setData: function (data) {
                this.itemData = { ...data }
                this.form = { ...data }
                if (this.selectedDataId !== 'new') {
					checkAuthentication(this.$router, this.$route).then(response => {
						getRoofPrices(this.selectedDataId).then(result => {
							this.setPricesData(result)
						}).catch(error => {
							reAuthenticate(this.$router, this.$route, error)
						})
					})
				}
            },
			getModelIndex(height, width) {
				for (let idx in this.pricesModel.prices) {
					if (this.pricesModel.prices[idx].width === width && this.pricesModel.prices[idx].height === height) {
						return idx;
					}
				}
			},
			setPricesData(prices) {
				this.pricesModel = prices;
				this.pricesWin = {};
				this.priceColNames = [];
				this.priceRowNames = [];
				for (let price in this.pricesModel.prices) {
					if (this.priceColNames.indexOf(this.pricesModel.prices[price].width) === -1) {
						this.priceColNames.push(this.pricesModel.prices[price].width);
					}
					if (this.priceRowNames.indexOf(this.pricesModel.prices[price].height) === -1) {
						this.priceRowNames.push(this.pricesModel.prices[price].height);
					}
				}
			},
			savePrices() {
				checkAuthentication(this.$router, this.$route).then(response => {
					saveRoofPrices(this.pricesModel).then(result => {
						window.location.reload()
					}).catch(error => {
						reAuthenticate(this.$router, this.$route, error)
					})
				})
			},
            getElementData: function () {
                checkAuthentication(this.$router, this.$route).then(response => {
					if (this.selectedDataId === 'new') {
						this.addItem();
						return;
					}
					getItem('roofwindow', this.selectedDataId).then(result => {
						this.setData(result)
					}).catch(error => {
						reAuthenticate(this.$router, this.$route, error)
					})
				})
			},
			addItem: function () {
				const item = {
					id: "new",

					name : "",
					type : 5,
					price : null,
					comment : "",
					minHeight : null,
					maxHeight : null,
					heightStep : null,
					minWidth : null,
					maxWidth : null,
					widthStep : null,
					photo: 0,
				};

				this.setData(item);

			},
			deleteItem: function () {
				checkAuthentication(this.$router, this.$route).then(response => {
					deleteItemRoof('roofwindow', JSON.stringify({ id: this.$route.params.id }), this.$route.params.id).then(result => {
						this.$router.push({ name: 'modelListRoof', params: { dictCode: 'modelListRoof' } })

					}).catch(error => {
						reAuthenticate(this.$router, this.$route, error)
					})
				})
			},
			saveItem: function () {
				if (this.form.id === 'new') {
					this.form.id = null
				}
				saveItem('roofwindow', JSON.stringify(this.form)).then(result => {
					this.$router.push({ name: 'modelListRoof', params: { dictCode: 'modelListRoof' } })
				}).catch(error => {
					reAuthenticate(this.$router, this.$route, error)
				})
			},
			checkEditableNames: function (name) {
				const editableNames = ['valueId', 'value', 'modelOrder']
				return (editableNames.indexOf(name) >= 0)
			},
		},
		created () {
			if (this.$route.params.action === 'delete') {
				this.deleteItem()
			} else {
				this.getElementData()
			}
		},
	}
</script>


<style lang="scss" scoped type="text/scss">
	.dictionary-data .md-field {
		padding-top: 16px;
		margin: 4px 0 24px;
	}

	.offset-left-16 {
		margin-left: 16px;
	}

	.short-inp {
		width: 85px;
	}
</style>
